import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function BackdropLoader({ open }: { open: boolean }) {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: 100000 }} open={open}>
      <CircularProgress color="secondary" />
    </Backdrop>
  );
}
